import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { MonthlyPensionAnnuityTypeIdEnum } from '../enum/shared/monthly-pension-annuity-type-id.enum';

export class MonthlyPensionAnnuityType extends BaseType implements Deserializable {
  public declare id: MonthlyPensionAnnuityTypeIdEnum;

  public onDeserialize(): void {}
}
